import React, { useEffect } from 'react';
import HeroBanner from '../components/common/HeroBanner/HeroBanner';
import ShipmentForm from '../components/home/ShipmentForm/ShipmentForm';
import './ShipmentFormPage.css';

const ShipmentFormPage = () => {
  useEffect(() => {
    document.title = 'NEST | Get Quote';
  }, []);
  return (
    <div className="shipment-page">
      <HeroBanner title="Get Quote" breadcrumbs={["Shipment Form"]} />
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="shipment-page-box">
                <ShipmentForm />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ShipmentFormPage;
